<template>
  <div class="notes-section">
    <label class="notes-label">Clock Drawing Score:</label>
    <div class="score-input-container">
      <div class="input-row">
        <label for="clock-score">Enter score (1-10):</label>
        <input 
            type="number" 
            id="clock-score"
            v-model="scoreValue" 
            min="1" 
            max="10" 
            class="score-input"
            @input="validateAndEmit"
        />
      </div>
      <div v-if="scoreError" class="score-error">{{ scoreError }}</div>
      <div class="score-helper">
        <p>(Note: Score must be a whole number between 1 and 10)</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClockScoreNum',
  props: {
    value: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      scoreValue: '',
      scoreError: ''
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue !== undefined && newValue !== null) {
          this.scoreValue = newValue.toString();
          this.validateScore();
        }
      }
    }
  },
  methods: {
    validateScore() {
      // Convert to number and check if it's an integer between 1 and 10
      const score = Number(this.scoreValue);
      
      if (this.scoreValue === '') {
        this.scoreError = '';
        return false;
      }
      
      if (isNaN(score) || !Number.isInteger(score)) {
        this.scoreError = 'Please enter a whole number';
        return false;
      }
      
      if (score < 1 || score > 10) {
        this.scoreError = 'Score must be between 1 and 10';
        return false;
      }
      
      this.scoreError = '';
      return true;
    },
    validateAndEmit() {
      if (this.validateScore()) {
        this.$emit('input', this.scoreValue);
      }
    },
    getScore() {
      return this.validateScore() ? this.scoreValue.toString() : '';
    }
  }
};
</script>

<style scoped>
.notes-section {
    padding: 20px 0;
}

.notes-label {
    font-weight: bold;
    display: block;
    margin-bottom: 10px;
}

.score-input-container {
    width: 100%;
    height: auto;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: #f0f0f0;
    padding: 10px;
    font-size: 16px;
}

.input-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.input-row label {
    margin-right: 10px;
}

.score-input {
    padding: 8px;
    width: 80px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: white;
}

.score-error {
    color: red;
    margin-top: 4px;
    font-size: 14px;
    font-weight: bold;
}

.score-helper {
    font-size: 12px;
    color: #666;
    margin-top: 5px;
}
</style> 